import React from "react";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import { FiActivity } from "react-icons/fi";
import { ExperimentOutlined } from "@ant-design/icons";


export const SidebarData = [
  {
    title: "Home",
    path: "/dashboard",
    icon: <AiIcons.AiFillHome />,
    cName: "nav-text",
  },
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: <FaIcons.FaTable />,
    cName: "nav-text",
  },
  {
    title: "Device Setting",
    path: "/iot-dashboard",
    icon: <FaIcons.FaTable />,
    cName: "nav-text",
  },
  {
    title: "Warehouse",
    path: "/warehouse",
    icon: <FaIcons.FaWarehouse />,
    cName: "nav-text",
  },
  {
    title: "Sensor QC",
    path: "/sensor-qc",
    icon: <ExperimentOutlined />,
    cName: "nav-text",
    permissions: ["warehouse_view", "warehouse_edit", "warehouse_manage"],
  },
  {
    title: "Makerting Zone",
    path: "/marketing-zone",
    icon: <FiActivity />,
    cName: "nav-text",
  },
];



// import GridOnIcon from '@mui/icons-material/GridOn';
// import WarehouseIcon from '@mui/icons-material/Warehouse';
// import HomeIcon from '@mui/icons-material/Home';

// export const DrawerData = [
//   {
//     title: "Home",
//     path: "/dashboard",
//     icon: HomeIcon
//   },
//   {
//     title: "Dashboard",
//     path: "/dashboard",
//     icon: GridOnIcon
//   },
//   {
//     title: "Warehouse",
//     path: "/warehouse",
//     icon: WarehouseIcon
//   }
// ]
